import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { ArrowUpRight, ArrowLeft } from 'lucide-react';
import { formatLongDate, formatTimeFromIso } from '../../lib/bookingTime';

export default function BookingForm({ date, slot, onBack, onSubmit, submitting, error }) {
  const [form, setForm] = useState({ first_name:'', last_name:'', email:'', company:'', notes:'' });
  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });
  const canSubmit = form.first_name.trim() && form.last_name.trim() && form.email.trim() && form.company.trim();

  const submit = (e) => {
    e.preventDefault();
    if (!canSubmit || submitting) return;
    onSubmit(form);
  };

  return (
    <div>
      <button onClick={onBack} className="inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase text-[#57534b] hover:text-[#B5876C] transition-colors mb-6">
        <ArrowLeft size={14} strokeWidth={1.5} /> Change time
      </button>

      <div className="border border-[#d9d2ca] bg-[#F3EEE7] p-5 mb-8">
        <p className="text-[11px] tracking-[0.24em] uppercase text-[#7a7369] mb-2">Your appointment</p>
        <p className="font-serif text-xl text-[#2E2C28] font-light leading-snug">Free Discovery Call · 30 minutes</p>
        <p className="text-sm text-[#4a463f] mt-2">{formatLongDate(date)} · {formatTimeFromIso(slot.start_iso)} UK Time</p>
        <p className="text-xs text-[#7a7369] mt-1">Google Meet link included</p>
      </div>

      <form onSubmit={submit} className="space-y-5">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          <Field label="First name *" name="first_name" value={form.first_name} onChange={onChange} />
          <Field label="Last name *" name="last_name" value={form.last_name} onChange={onChange} />
        </div>
        <Field label="Work email *" name="email" type="email" value={form.email} onChange={onChange} />
        <Field label="Company name *" name="company" value={form.company} onChange={onChange} />

        <div>
          <label className="block text-[11px] tracking-[0.22em] uppercase text-[#57534b] mb-2">Anything you'd like Hannah to know before the call?</label>
          <Textarea name="notes" value={form.notes} onChange={onChange} rows={4} className="bg-transparent border-0 border-b border-[#c9c0b3] focus-visible:ring-0 focus-visible:border-[#B5876C] rounded-none px-0 text-[#2E2C28] placeholder:text-[#a09689] text-base font-light" placeholder="Optional — e.g. stage, team size, main sales challenge..." />
        </div>

        {error && (
          <div className="text-sm text-[#8a3a2e] bg-[#f4dcd3] border border-[#e3b5a8] px-4 py-3" role="alert">{error}</div>
        )}

        <div className="pt-2">
          <Button type="submit" disabled={!canSubmit || submitting} data-testid="confirm-btn" className="bg-[#2E2C28] hover:bg-[#B5876C] text-[#EBE4DE] rounded-none h-14 px-8 text-[12px] tracking-[0.2em] uppercase font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
            <span className="inline-flex items-center gap-3">
              {submitting ? 'Confirming…' : 'Confirm Discovery Call'}
              {!submitting && <ArrowUpRight size={16} strokeWidth={1.5} />}
            </span>
          </Button>
        </div>
      </form>
    </div>
  );
}

function Field({ label, ...props }) {
  return (
    <div>
      <label className="block text-[11px] tracking-[0.22em] uppercase text-[#57534b] mb-2">{label}</label>
      <Input {...props} className="bg-transparent border-0 border-b border-[#c9c0b3] focus-visible:ring-0 focus-visible:border-[#B5876C] rounded-none px-0 text-[#2E2C28] placeholder:text-[#a09689] text-base font-light h-11" />
    </div>
  );
}
